
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iDxDj", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $3lWl0 = parcelRequire("3lWl0");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $inPa6 = parcelRequire("inPa6");


var $jMyy4 = parcelRequire("jMyy4");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $3jwuS = parcelRequire("3jwuS");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $3Xs1I = parcelRequire("3Xs1I");

var $c0urc = parcelRequire("c0urc");



var $e4o8D = parcelRequire("e4o8D");


var $7Sm4c = parcelRequire("7Sm4c");


var $laFNM = parcelRequire("laFNM");


var $qP1yw = parcelRequire("qP1yw");


var $8EyOs = parcelRequire("8EyOs");


var $bJX6u = parcelRequire("bJX6u");

function $f084987bc41bc5d5$var$computeContentStateValuesFromData(data, defaultStatesArray, customStatesArray, isDraft, contentId, isViewOnlyMode) {
    const newContentStateValues = Object.assign({}, (0, $bJX6u.defaultValues));
    /**  Computes content state values from query response data. Used for both SSR bootstrap (useEffect never runs on
    server, so we compute state from preloaded data for initial render) and client useEffect (setInitialValues).
    Setting shouldRunContentStateEffect = false prevents the effect from running again on parent re-renders
    (EditorContentState lives in breadcrumbs/title area), which would otherwise reset the values.
  */ newContentStateValues.shouldRunContentStateEffect = false;
    newContentStateValues.contentState = data?.singleContent?.contentState || null;
    newContentStateValues.contentStateLastUpdated = data?.singleContent?.contentStateLastUpdated?.value || null;
    newContentStateValues.defaultStatesArray = defaultStatesArray;
    newContentStateValues.customStatesArray = customStatesArray;
    // Only check availableContentStates when the user has edit permission.
    // In view-only mode, availableContentStates is either skipped via @skip directive
    // or absent entirely (renderer fallback query), so we must not treat its absence
    // as "content states disabled".
    if (!isViewOnlyMode) {
        const editorData = data;
        const isSuggestedContentStatesDisabled = !editorData?.availableContentStates?.spaceContentStates;
        const isCustomContentStatesDisabled = !editorData?.availableContentStates?.customContentStates;
        const isContentStatesDisabled = isSuggestedContentStatesDisabled && isCustomContentStatesDisabled;
        if (isContentStatesDisabled) newContentStateValues.isContentStateEnabled = false;
        else if (isSuggestedContentStatesDisabled) newContentStateValues.isSuggestedEnabled = false;
        else if (isCustomContentStatesDisabled) newContentStateValues.isCustomEnabled = false;
    }
    newContentStateValues.lastFetchedIsDraft = isDraft;
    newContentStateValues.lastFetchedContentId = contentId;
    return newContentStateValues;
}
const $f084987bc41bc5d5$var$EditorContentStateDataGetter = (t0)=>{
    const $ = (0, $frIzR.c)(89);
    const { contentId: contentId, contentType: contentType, contentStateState: contentStateState, isPublishingContent: isPublishingContent, userOffline: userOffline, onContentStateMenuToggle: onContentStateMenuToggle, floatingToolbarButtonStyle: floatingToolbarButtonStyle, renderPlusButtonEmptyState: renderPlusButtonEmptyState, isDetailsPanel: isDetailsPanel, onClick: onClick, isViewMode: isViewMode, canEdit: canEdit } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isCurrentPageLive = (0, $3jwuS.useIsCurrentPageLive)();
    const isDraft = !isViewMode && !isCurrentPageLive;
    const { approvalRequest: approvalRequest } = (0, $laFNM.useApprovals)();
    const hasApprovalStatus = !!approvalRequest?.application?.workflowStatusId;
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const isViewOnlyMode = !!(isViewMode && canEdit === false);
    let t1;
    if ($[0] !== isCurrentPageLive) {
        t1 = (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) ? false : !isCurrentPageLive;
        $[0] = isCurrentPageLive;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true);
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== contentId || $[4] !== isDraft || $[5] !== isViewOnlyMode || $[6] !== t1) {
        t3 = {
            contentId: contentId,
            isDraft: isDraft,
            shouldSkipContentStateLastUpdated: t1,
            isApprovalsFgOn: t2,
            format: (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) ? "MILLIS" : "USER_FRIENDLY",
            shouldSkipAvailableContentStates: isViewOnlyMode,
            shouldSkipEditOnlyFields: isViewOnlyMode
        };
        $[3] = contentId;
        $[4] = isDraft;
        $[5] = isViewOnlyMode;
        $[6] = t1;
        $[7] = t3;
    } else t3 = $[7];
    const t4 = t3;
    const t5 = (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) ? false : !contentStateState.state.shouldRunContentStateEffect;
    let t6;
    if ($[8] !== t4 || $[9] !== t5) {
        t6 = {
            fetchPolicy: Boolean(window.__SSR_RENDERED__) ? "cache-first" : "network-only",
            variables: t4,
            skip: t5
        };
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    const { data: data, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $3lWl0.default), {
        ...t6,
        __callerPackage__: "@confluence/content-state"
    });
    let t7;
    if ($[11] !== contentId || $[12] !== isDraft) {
        t7 = {
            contentId: contentId,
            isDraft: isDraft,
            format: "USER_FRIENDLY"
        };
        $[11] = contentId;
        $[12] = isDraft;
        $[13] = t7;
    } else t7 = $[13];
    const t8 = t7;
    const t9 = !isViewOnlyMode;
    let t10;
    if ($[14] !== t8 || $[15] !== t9) {
        t10 = {
            fetchPolicy: "cache-first",
            variables: t8,
            skip: t9
        };
        $[14] = t8;
        $[15] = t9;
        $[16] = t10;
    } else t10 = $[16];
    const { data: rendererData } = (0, $jMyy4.useQueryInterop)((0, $8EyOs.default), {
        ...t10,
        __callerPackage__: "@confluence/content-state"
    });
    const ssrContentStateData = renderServerPlaceholder && isViewOnlyMode && !data && !rendererData ? window.__SSR_CONTENT_STATE__ : null;
    const effectiveData = data ?? (isViewOnlyMode ? rendererData ?? ssrContentStateData : null);
    data?.availableContentStates?.spaceContentStates;
    let t11;
    if ($[17] !== data?.availableContentStates?.spaceContentStates) {
        t11 = data?.availableContentStates?.spaceContentStates?.filter($f084987bc41bc5d5$var$_temp) || [];
        $[17] = data?.availableContentStates?.spaceContentStates;
        $[18] = t11;
    } else t11 = $[18];
    const defaultStatesArray = t11;
    let t12;
    if ($[19] !== data?.availableContentStates?.customContentStates) {
        t12 = ()=>data?.availableContentStates?.customContentStates?.filter($f084987bc41bc5d5$var$_temp2) || [];
        $[19] = data?.availableContentStates?.customContentStates;
        $[20] = t12;
    } else t12 = $[20];
    data?.availableContentStates?.customContentStates;
    let t13;
    if ($[21] !== t12) {
        t13 = t12();
        $[21] = t12;
        $[22] = t13;
    } else t13 = $[22];
    const customStatesArray = t13;
    let ssrContentState = null;
    if (renderServerPlaceholder && isViewOnlyMode && effectiveData && effectiveData.singleContent?.id === contentId && contentStateState.state.lastFetchedIsDraft === null && ((0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) || contentStateState.state.shouldRunContentStateEffect)) {
        let t14;
        if ($[23] !== contentId || $[24] !== customStatesArray || $[25] !== defaultStatesArray || $[26] !== effectiveData || $[27] !== isDraft || $[28] !== isViewOnlyMode) {
            t14 = $f084987bc41bc5d5$var$computeContentStateValuesFromData(effectiveData, defaultStatesArray, customStatesArray, isDraft, contentId, isViewOnlyMode);
            $[23] = contentId;
            $[24] = customStatesArray;
            $[25] = defaultStatesArray;
            $[26] = effectiveData;
            $[27] = isDraft;
            $[28] = isViewOnlyMode;
            $[29] = t14;
        } else t14 = $[29];
        ssrContentState = t14;
    }
    if (renderServerPlaceholder && !ssrContentState && !effectiveData && (hasApprovalStatus || isViewOnlyMode) && contentStateState.state.lastFetchedIsDraft === null && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true)) {
        let t14;
        if ($[30] !== contentId || $[31] !== isDraft) {
            t14 = {
                ...(0, $bJX6u.defaultValues),
                isContentStateEnabled: false,
                shouldRunContentStateEffect: false,
                lastFetchedIsDraft: isDraft,
                lastFetchedContentId: contentId
            };
            $[30] = contentId;
            $[31] = isDraft;
            $[32] = t14;
        } else t14 = $[32];
        ssrContentState = t14;
    }
    const effectiveState = ssrContentState ?? contentStateState.state;
    let t14;
    if ($[33] !== contentStateState.state.lastFetchedIsDraft || $[34] !== isDraft) {
        t14 = contentStateState.state.lastFetchedIsDraft !== null && contentStateState.state.lastFetchedIsDraft !== isDraft && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true);
        $[33] = contentStateState.state.lastFetchedIsDraft;
        $[34] = isDraft;
        $[35] = t14;
    } else t14 = $[35];
    const isTransitioning = t14;
    let t15;
    let t16;
    if ($[36] !== contentStateState || $[37] !== isTransitioning) {
        t15 = ()=>{
            if (isTransitioning) contentStateState.resetToDefaults();
        };
        t16 = [
            isTransitioning,
            contentStateState
        ];
        $[36] = contentStateState;
        $[37] = isTransitioning;
        $[38] = t15;
        $[39] = t16;
    } else {
        t15 = $[38];
        t16 = $[39];
    }
    (0, $42omo.useEffect)(t15, t16);
    let t17;
    let t18;
    if ($[40] !== contentId || $[41] !== contentStateState || $[42] !== effectiveData || $[43] !== error || $[44] !== isDraft || $[45] !== isTransitioning || $[46] !== isViewOnlyMode) {
        t17 = ()=>{
            if (!isTransitioning && error) {
                if (isViewOnlyMode && effectiveData) (0, $7Sm4c.markErrorAsHandled)(error);
                else if (!effectiveData && contentStateState.state.shouldRunContentStateEffect && contentStateState.state.lastFetchedIsDraft === null) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    contentStateState.setInitialValues({
                        ...(0, $bJX6u.defaultValues),
                        isContentStateEnabled: false,
                        shouldRunContentStateEffect: false,
                        lastFetchedIsDraft: isDraft,
                        lastFetchedContentId: contentId
                    });
                }
            }
        };
        t18 = [
            error,
            effectiveData,
            contentStateState,
            isDraft,
            contentId,
            isTransitioning,
            isViewOnlyMode
        ];
        $[40] = contentId;
        $[41] = contentStateState;
        $[42] = effectiveData;
        $[43] = error;
        $[44] = isDraft;
        $[45] = isTransitioning;
        $[46] = isViewOnlyMode;
        $[47] = t17;
        $[48] = t18;
    } else {
        t17 = $[47];
        t18 = $[48];
    }
    (0, $42omo.useEffect)(t17, t18);
    let t19;
    let t20;
    if ($[49] !== contentId || $[50] !== contentStateState || $[51] !== customStatesArray || $[52] !== defaultStatesArray || $[53] !== effectiveData || $[54] !== isDraft || $[55] !== isTransitioning || $[56] !== isViewOnlyMode) {
        t19 = ()=>{
            if (isTransitioning) return;
            if (effectiveData && effectiveData.singleContent?.id === contentId && ((0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) || contentStateState.state.shouldRunContentStateEffect)) {
                if ((0, $9wGTI.fg)("confluence_approvals_byline_changes") && contentStateState.state.isUpdating) {
                    contentStateState.setIsUpdating(false);
                    return;
                }
                const computed = $f084987bc41bc5d5$var$computeContentStateValuesFromData(effectiveData, defaultStatesArray, customStatesArray, isDraft, contentId, isViewOnlyMode);
                contentStateState.setInitialValues(computed);
            }
        };
        t20 = [
            effectiveData,
            contentStateState,
            defaultStatesArray,
            customStatesArray,
            isDraft,
            isTransitioning,
            contentId,
            isViewOnlyMode
        ];
        $[49] = contentId;
        $[50] = contentStateState;
        $[51] = customStatesArray;
        $[52] = defaultStatesArray;
        $[53] = effectiveData;
        $[54] = isDraft;
        $[55] = isTransitioning;
        $[56] = isViewOnlyMode;
        $[57] = t19;
        $[58] = t20;
    } else {
        t19 = $[57];
        t20 = $[58];
    }
    (0, $42omo.useEffect)(t19, t20);
    let t21;
    if ($[59] !== canEdit || $[60] !== contentId || $[61] !== contentType || $[62] !== effectiveState || $[63] !== floatingToolbarButtonStyle || $[64] !== hasApprovalStatus || $[65] !== isTransitioning || $[66] !== isViewMode || $[67] !== renderPlusButtonEmptyState) {
        t21 = !isTransitioning && !(effectiveState.lastFetchedContentId !== null && effectiveState.lastFetchedContentId !== contentId && (0, $9wGTI.fg)("confluence_frontend_transition_preloading_system")) && !(effectiveState.shouldRunContentStateEffect && effectiveState.lastFetchedIsDraft === null) && !(!effectiveState.isContentStateEnabled && !effectiveState.contentState && !hasApprovalStatus && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true)) && !(isViewMode && !canEdit && !(effectiveState.contentState || hasApprovalStatus) && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true)) && !(isViewMode && contentType === "blogpost" && !(effectiveState.contentState || hasApprovalStatus) && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true)) && !(!(effectiveState.contentState || hasApprovalStatus) && !floatingToolbarButtonStyle && !renderPlusButtonEmptyState && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true));
        $[59] = canEdit;
        $[60] = contentId;
        $[61] = contentType;
        $[62] = effectiveState;
        $[63] = floatingToolbarButtonStyle;
        $[64] = hasApprovalStatus;
        $[65] = isTransitioning;
        $[66] = isViewMode;
        $[67] = renderPlusButtonEmptyState;
        $[68] = t21;
    } else t21 = $[68];
    const shouldRenderUI = t21;
    if (shouldRenderUI && isPublishingContent) createAnalyticsEvent({
        type: "sendTrackEvent",
        data: {
            action: "publishedWithContentState",
            actionSubject: "page",
            objectId: contentId,
            source: "editorContentState",
            attributes: {
                contentStatus: isViewMode ? "CURRENT" : "DRAFT"
            }
        }
    }).fire();
    let t22;
    if ($[69] !== isViewMode || $[70] !== refetch) {
        t22 = isViewMode && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Xs1I.QuickReloadSubscriber), {
            name: "content-state",
            types: [
                (0, $c0urc.ReloadType).content
            ],
            reload: refetch
        });
        $[69] = isViewMode;
        $[70] = refetch;
        $[71] = t22;
    } else t22 = $[71];
    let t23;
    if ($[72] !== canEdit || $[73] !== contentId || $[74] !== contentStateState || $[75] !== contentType || $[76] !== effectiveState || $[77] !== floatingToolbarButtonStyle || $[78] !== isDetailsPanel || $[79] !== isViewMode || $[80] !== onClick || $[81] !== onContentStateMenuToggle || $[82] !== renderPlusButtonEmptyState || $[83] !== shouldRenderUI || $[84] !== userOffline) {
        t23 = shouldRenderUI && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $qP1yw.LazyEditorContentStateComponent), {
            contentId: contentId,
            contentType: contentType,
            contentStateState: {
                ...contentStateState,
                state: effectiveState
            },
            userOffline: userOffline,
            onContentStateMenuToggle: onContentStateMenuToggle,
            floatingToolbarButtonStyle: floatingToolbarButtonStyle,
            renderPlusButtonEmptyState: renderPlusButtonEmptyState,
            isDetailsPanel: isDetailsPanel,
            onClick: onClick,
            isViewMode: isViewMode,
            canEdit: canEdit
        });
        $[72] = canEdit;
        $[73] = contentId;
        $[74] = contentStateState;
        $[75] = contentType;
        $[76] = effectiveState;
        $[77] = floatingToolbarButtonStyle;
        $[78] = isDetailsPanel;
        $[79] = isViewMode;
        $[80] = onClick;
        $[81] = onContentStateMenuToggle;
        $[82] = renderPlusButtonEmptyState;
        $[83] = shouldRenderUI;
        $[84] = userOffline;
        $[85] = t23;
    } else t23 = $[85];
    let t24;
    if ($[86] !== t22 || $[87] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t22, t23);
        $[86] = t22;
        $[87] = t23;
        $[88] = t24;
    } else t24 = $[88];
    return t24;
};
const $f084987bc41bc5d5$var$EditorContentStateWithErrorBoundary = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
})($f084987bc41bc5d5$var$EditorContentStateDataGetter);
const $f084987bc41bc5d5$var$contentStateContainers = [
    (0, $bJX6u.ContentStateStateContainer)
];
const $f084987bc41bc5d5$export$2791e79b1a186ba4 = (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: $f084987bc41bc5d5$var$contentStateContainers
        }, (contentStateState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f084987bc41bc5d5$var$EditorContentStateWithErrorBoundary, {
                ...props,
                contentStateState: contentStateState
            }));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
function $f084987bc41bc5d5$var$_temp(i) {
    return !!i;
}
function $f084987bc41bc5d5$var$_temp2(i_0) {
    return !!i_0;
}
module.exports["EditorContentState"] = $f084987bc41bc5d5$export$2791e79b1a186ba4;

});

parcelRegister("3lWl0", function(module, exports) {
/**
 * @generated SignedSource<<020826b2d97213ec125edeb03abfc3f5>>
 * @relayHash e78f45ef84b0309b46cad2982bdd129a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d9dbad7f6be18f479464c7740ecc608e88f02669cea51d9e028e75b6b84f4eb9
const $34dd87dd4e33f987$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "format"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isApprovalsFgOn"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldSkipAvailableContentStates"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldSkipContentStateLastUpdated"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldSkipEditOnlyFields"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "Variable",
        "name": "isDraft",
        "variableName": "isDraft"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "color"
    }, v11 = {
        "kind": "ScalarField",
        "name": "restrictionLevel"
    }, v12 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v7 /*: any*/ ,
                {
                    "args": [
                        v8 /*: any*/ 
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        {
                            "condition": "shouldSkipEditOnlyFields",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isCallerPermitted"
                                }
                            ]
                        },
                        {
                            "condition": "isApprovalsFgOn",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifierAaid"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldSkipContentStateLastUpdated",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "format",
                                    "variableName": "format"
                                },
                                v8 /*: any*/ 
                            ],
                            "concreteType": "ConfluenceDate",
                            "kind": "LinkedField",
                            "name": "contentStateLastUpdated",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "shouldSkipAvailableContentStates",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        }
                    ],
                    "concreteType": "AvailableContentStates",
                    "kind": "LinkedField",
                    "name": "availableContentStates",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentState",
                            "kind": "LinkedField",
                            "name": "customContentStates",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "ContentState",
                            "kind": "LinkedField",
                            "name": "spaceContentStates",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v7 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EditorContentStateQuery",
            "selections": v12 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EditorContentStateQuery",
            "selections": v12 /*: any*/ 
        },
        "params": {
            "cacheID": "e78f45ef84b0309b46cad2982bdd129a",
            "id": "d9dbad7f6be18f479464c7740ecc608e88f02669cea51d9e028e75b6b84f4eb9",
            "metadata": {},
            "name": "EditorContentStateQuery",
            "operationKind": "query",
            "text": "query EditorContentStateQuery($contentId:ID!,$isDraft:Boolean!,$isApprovalsFgOn:Boolean!,$format:GraphQLDateFormat!,$shouldSkipContentStateLastUpdated:Boolean!,$shouldSkipAvailableContentStates:Boolean=false,$shouldSkipEditOnlyFields:Boolean=false){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel,isCallerPermitted@skip(if:$shouldSkipEditOnlyFields),lastModifierAaid@include(if:$isApprovalsFgOn)},contentStateLastUpdated(format:$format,isDraft:$isDraft)@skip(if:$shouldSkipContentStateLastUpdated){value}},availableContentStates(contentId:$contentId)@skip(if:$shouldSkipAvailableContentStates){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}}}"
        }
    };
}();
$34dd87dd4e33f987$var$node.hash = "f76426744ff28f16601d3ae4d51a17fb";
var $34dd87dd4e33f987$export$2e2bcd8739ae039 = $34dd87dd4e33f987$var$node;
module.exports["default"] = $34dd87dd4e33f987$export$2e2bcd8739ae039;

});

parcelRegister("aJv6Q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("e4o8D", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");


var $60cDW = parcelRequire("60cDW");

const $2679ebd914f0a083$var$emptySubscribe = ()=>()=>{};
const $2679ebd914f0a083$var$getClientSnapshot = ()=>false;
const $2679ebd914f0a083$var$getServerSnapshot = ()=>true;
const $2679ebd914f0a083$var$editRoutes = [
    (0, $1NBp8.EDIT_PAGE_V2),
    (0, $1NBp8.EDIT_BLOG_V2),
    (0, $1NBp8.EDIT_PAGE),
    (0, $1NBp8.EDIT_BLOG),
    (0, $1NBp8.EDIT_PAGE_EMBED)
];
const $2679ebd914f0a083$var$isEditOrLiveRoute = ()=>{
    const { uri: uri, isLivePage: isLivePage } = (0, $60cDW.getSSRRenderInputs)();
    if (isLivePage) return true;
    if (uri) return $2679ebd914f0a083$var$editRoutes.some((route)=>route.match(uri));
    return false;
};
const $2679ebd914f0a083$export$96e8e9e8e57310bb = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const renderServerPlaceholderOnNonHydrate = t0 === undefined ? false : t0;
    const isSSRSync = (0, $42omo.useSyncExternalStore)($2679ebd914f0a083$var$emptySubscribe, $2679ebd914f0a083$var$getClientSnapshot, $2679ebd914f0a083$var$getServerSnapshot);
    const optimizedRenderServerPlaceholder = (0, $42omo.useDeferredValue)(isSSRSync);
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            if ($2679ebd914f0a083$var$isEditOrLiveRoute() || !(0, $6mKj3.expVal)("confluence_optimize_render_server_placeholder", "isEnabled", false)) setRenderServerPlaceholder(false);
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[2] !== optimizedRenderServerPlaceholder || $[3] !== renderServerPlaceholder) {
        t3 = !$2679ebd914f0a083$var$isEditOrLiveRoute() && (0, $6mKj3.expVal)("confluence_optimize_render_server_placeholder", "isEnabled", false) ? optimizedRenderServerPlaceholder : renderServerPlaceholder;
        $[2] = optimizedRenderServerPlaceholder;
        $[3] = renderServerPlaceholder;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};
module.exports["useRenderServerPlaceholder"] = $2679ebd914f0a083$export$96e8e9e8e57310bb;

});

parcelRegister("qP1yw", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $lJswu = parcelRequire("lJswu");


var $dzxx6 = parcelRequire("dzxx6");


const $d4d6077acc6972b1$export$a5601a59fc831df9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "qET7f",
    name: "LazyEditorContentStateComponent",
    loader: async ()=>{
        return (await (parcelRequire("dLDYF"))).EditorContentStateComponent;
    },
    loading: (0, $lJswu.ContentStateSkeleton)
});

const $d4d6077acc6972b1$export$c49c9d91fa2cc91e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "OYB6O",
    name: "LazyRendererContentStateComponent",
    loader: async ()=>{
        return (await (parcelRequire("9EUwJ"))).RendererContentStateComponent;
    },
    loading: (0, $dzxx6.RendererContentStatePlaceholder)
});
module.exports["LazyEditorContentStateComponent"] = $d4d6077acc6972b1$export$a5601a59fc831df9;
module.exports["LazyRendererContentStateComponent"] = $d4d6077acc6972b1$export$c49c9d91fa2cc91e;

});

parcelRegister("lJswu", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $kpYGL = parcelRequire("kpYGL");

const $668f42f1e7477ee9$export$ad2edbf08e0f7b11 = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "60px",
            height: "20px",
            isShimmering: true,
            testId: "content-state-skeleton"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["ContentStateSkeleton"] = $668f42f1e7477ee9$export$ad2edbf08e0f7b11;

});

parcelRegister("dzxx6", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $3jwuS = parcelRequire("3jwuS");


var $9wGTI = parcelRequire("9wGTI");

const $62a49c8d20755563$var$loadingPlaceholderBaseStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer',
    minHeight: '32px',
    borderRadius: 'radius.small',
    paddingRight: 'space.100'
});
const $62a49c8d20755563$var$placeHolderBackroundColorStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral'
});
const $62a49c8d20755563$var$subtlePlaceholderBackgroundColorStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'utility.elevation.surface.current'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62a49c8d20755563$var$ContentStateNamePlaceholderWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_k48p1wq8 _3um015vq",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $62a49c8d20755563$var$classicContentStateColorPlaceholderStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.xlarge',
    height: '12px',
    width: '12px',
    marginTop: 'space.0',
    marginBottom: 'space.0',
    marginLeft: 'space.100',
    marginRight: 'space.100',
    backgroundColor: 'color.background.neutral'
});
const $62a49c8d20755563$var$subtleContentStateColorPlaceholderStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.full',
    height: '10px',
    width: '10px',
    marginLeft: 'space.050',
    marginRight: 'space.075',
    backgroundColor: 'color.background.neutral'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62a49c8d20755563$var$StyledBorder = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18s81b3y _1kl71qn1 _1e0c1o8l _1bsbt94y _4t3i7vkz _1wpz1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $62a49c8d20755563$var$flexWrapperStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.075',
    marginRight: 'space.075'
});
const $62a49c8d20755563$export$6679211e6c7373d = (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { contentState: contentState, isDraft: isDraft } = t0;
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const t1 = isLivePage || (0, $9wGTI.fg)("cc_page_experiences_new_editor_byline") ? $62a49c8d20755563$var$subtlePlaceholderBackgroundColorStyles : $62a49c8d20755563$var$placeHolderBackroundColorStyles;
    let t2;
    if ($[0] !== t1) {
        t2 = [
            $62a49c8d20755563$var$loadingPlaceholderBaseStyles,
            t1
        ];
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const contentStateLoadingPlaceholderStyles = t2;
    const t3 = isLivePage || (0, $9wGTI.fg)("cc_page_experiences_new_editor_byline") ? $62a49c8d20755563$var$subtleContentStateColorPlaceholderStyles : $62a49c8d20755563$var$classicContentStateColorPlaceholderStyles;
    let t4;
    if ($[2] !== t3) {
        t4 = [
            t3
        ];
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    const contentStateColorPlaceholderStyles = t4;
    const t5 = isLivePage || (0, $9wGTI.fg)("cc_page_experiences_new_editor_byline") ? "subtle-renderer-content-state-placeholder" : "renderer-content-state-placeholder";
    const t6 = isLivePage || (0, $9wGTI.fg)("cc_page_experiences_new_editor_byline") ? "subtle-renderer-content-state-color-placeholder" : "renderer-content-state-color-placeholder";
    let t7;
    if ($[4] !== contentStateColorPlaceholderStyles || $[5] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: contentStateColorPlaceholderStyles,
            testId: t6
        });
        $[4] = contentStateColorPlaceholderStyles;
        $[5] = t6;
        $[6] = t7;
    } else t7 = $[6];
    const t8 = contentState?.name;
    let t9;
    if ($[7] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($62a49c8d20755563$var$ContentStateNamePlaceholderWrapper, null, t8);
        $[7] = t8;
        $[8] = t9;
    } else t9 = $[8];
    let t10;
    if ($[9] !== contentStateLoadingPlaceholderStyles || $[10] !== t5 || $[11] !== t7 || $[12] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            as: "li",
            alignItems: "center",
            xcss: contentStateLoadingPlaceholderStyles,
            testId: t5
        }, t7, t9);
        $[9] = contentStateLoadingPlaceholderStyles;
        $[10] = t5;
        $[11] = t7;
        $[12] = t9;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] !== isDraft) {
        t11 = !isDraft && !(0, $9wGTI.fg)("cc_page_experiences_new_editor_byline") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($62a49c8d20755563$var$StyledBorder, {
            "data-testid": "placeholder-vertical-line"
        });
        $[14] = isDraft;
        $[15] = t11;
    } else t11 = $[15];
    let t12;
    if ($[16] !== t10 || $[17] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            xcss: $62a49c8d20755563$var$flexWrapperStyles
        }, t10, t11);
        $[16] = t10;
        $[17] = t11;
        $[18] = t12;
    } else t12 = $[18];
    return t12;
};
module.exports["RendererContentStatePlaceholder"] = $62a49c8d20755563$export$6679211e6c7373d;

});

parcelRegister("dLDYF", function(module, exports) {

let $a05eacd4ce4d5bfb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a05eacd4ce4d5bfb$var$load("9gVav"),
    $a05eacd4ce4d5bfb$var$load("elrCw"),
    $a05eacd4ce4d5bfb$var$load("3dFwk"),
    $a05eacd4ce4d5bfb$var$load("6wr18"),
    $a05eacd4ce4d5bfb$var$load("e3k4I"),
    $a05eacd4ce4d5bfb$var$load("k5bum"),
    $a05eacd4ce4d5bfb$var$load("1H5IN"),
    $a05eacd4ce4d5bfb$var$load("3GuOt"),
    $a05eacd4ce4d5bfb$var$load("8Rc3a"),
    $a05eacd4ce4d5bfb$var$load("h4Nf7"),
    $a05eacd4ce4d5bfb$var$load("U4fwL"),
    $a05eacd4ce4d5bfb$var$load("kaB35"),
    $a05eacd4ce4d5bfb$var$load("kHOMt"),
    $a05eacd4ce4d5bfb$var$load("im7NY"),
    $a05eacd4ce4d5bfb$var$load("ffEVr"),
    $a05eacd4ce4d5bfb$var$load("i0T1W"),
    $a05eacd4ce4d5bfb$var$load("cj0Rr"),
    $a05eacd4ce4d5bfb$var$load("7EorR"),
    $a05eacd4ce4d5bfb$var$load("hhss7"),
    $a05eacd4ce4d5bfb$var$load("Wowvf"),
    $a05eacd4ce4d5bfb$var$load("etEYy"),
    $a05eacd4ce4d5bfb$var$load("9DDT5")
]).then(()=>parcelRequire('2TweP'));

});

parcelRegister("9EUwJ", function(module, exports) {

let $7083b28f0e74da40$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7083b28f0e74da40$var$load("jcEo4").then(()=>parcelRequire('llcSD'));

});

parcelRegister("8EyOs", function(module, exports) {
/**
 * @generated SignedSource<<d6eefc5a03716abdbaca8e40915faea8>>
 * @relayHash 0c7e59589b279881378fc2baf2dcf71b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0dfd28d4a6a045f36efbb873be6de601dedb01632d322cff86c74287f8c186bb
const $231a29dfed7a7165$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "format"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isDraft",
                            "variableName": "isDraft"
                        }
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "color"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "restrictionLevel"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "format",
                            "variableName": "format"
                        }
                    ],
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "contentStateLastUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RendererContentStateQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RendererContentStateQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "0c7e59589b279881378fc2baf2dcf71b",
            "id": "0dfd28d4a6a045f36efbb873be6de601dedb01632d322cff86c74287f8c186bb",
            "metadata": {},
            "name": "RendererContentStateQuery",
            "operationKind": "query",
            "text": "query RendererContentStateQuery($contentId:ID!,$isDraft:Boolean!,$format:GraphQLDateFormat){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel},contentStateLastUpdated(format:$format){value}}}"
        }
    };
}();
$231a29dfed7a7165$var$node.hash = "a7f67982771d8fe760ba232b1260bced";
var $231a29dfed7a7165$export$2e2bcd8739ae039 = $231a29dfed7a7165$var$node;
module.exports["default"] = $231a29dfed7a7165$export$2e2bcd8739ae039;

});

parcelRegister("bJX6u", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");

const $258e0d668fcd3778$export$7e292eecf5a8f340 = {
    contentState: null,
    contentStateLastUpdated: null,
    shouldRunContentStateEffect: true,
    defaultStatesArray: [],
    customStatesArray: [],
    isContentStateEnabled: true,
    isSuggestedEnabled: true,
    isCustomEnabled: true,
    isUpdating: false,
    lastFetchedIsDraft: null,
    lastFetchedContentId: null
};
class $258e0d668fcd3778$export$ade89fbf99f42685 extends (0, $T1bCI.Container) {
    populateState(ssrContentStateData) {
        const newContentStateValues = Object.assign({}, $258e0d668fcd3778$export$7e292eecf5a8f340);
        newContentStateValues.shouldRunContentStateEffect = false;
        newContentStateValues.contentState = ssrContentStateData?.singleContent?.contentState || null;
        newContentStateValues.contentStateLastUpdated = ssrContentStateData?.singleContent?.contentStateLastUpdated?.value || null;
        newContentStateValues.defaultStatesArray = ssrContentStateData?.availableContentStates?.spaceContentStates?.filter((i)=>!!i) || [];
        newContentStateValues.customStatesArray = ssrContentStateData?.availableContentStates?.customContentStates?.filter((i)=>!!i) || [];
        // If an admin has turned off a toggle, BE returns us the value as null
        // If an empty array is returned [], means the feature is still enabled - there's just no values in there.
        // if both return as null it means the admin disabled content states
        const isSuggestedContentStatesDisabled = !ssrContentStateData?.availableContentStates?.spaceContentStates;
        const isCustomContentStatesDisabled = !ssrContentStateData?.availableContentStates?.customContentStates;
        const isContentStatesDisabled = isSuggestedContentStatesDisabled && isCustomContentStatesDisabled;
        if (isContentStatesDisabled) newContentStateValues.isContentStateEnabled = false;
        else if (isSuggestedContentStatesDisabled) // if spaceContentStates is null, admin disabled suggested
        newContentStateValues.isSuggestedEnabled = false;
        else if (isCustomContentStatesDisabled) // if customContentStates is null, admin disabled custom
        newContentStateValues.isCustomEnabled = false;
        this.state = newContentStateValues;
    }
    constructor(ssrContentStateData){
        super();
        this.state = {
            ...$258e0d668fcd3778$export$7e292eecf5a8f340
        };
        this.setContentState = (contentState)=>this.setState({
                contentState: contentState
            });
        this.setShouldRunContentStateEffect = (shouldRunContentStateEffect)=>this.setState({
                shouldRunContentStateEffect: shouldRunContentStateEffect
            });
        this.setDefaultStatesArray = (defaultStatesArray)=>this.setState({
                defaultStatesArray: defaultStatesArray
            });
        this.setCustomStatesArray = (customStatesArray)=>this.setState({
                customStatesArray: customStatesArray
            });
        this.setIsContentStateEnabled = (isContentStateEnabled)=>this.setState({
                isContentStateEnabled: isContentStateEnabled
            });
        this.setIsSuggestedEnabled = (isSuggestedEnabled)=>this.setState({
                isSuggestedEnabled: isSuggestedEnabled
            });
        this.setIsCustomEnabled = (isCustomEnabled)=>this.setState({
                isCustomEnabled: isCustomEnabled
            });
        this.setIsUpdating = (isUpdating)=>this.setState({
                isUpdating: isUpdating
            });
        this.setLastFetchedIsDraft = (lastFetchedIsDraft)=>this.setState({
                lastFetchedIsDraft: lastFetchedIsDraft
            });
        this.setLastFetchedContentId = (lastFetchedContentId)=>this.setState({
                lastFetchedContentId: lastFetchedContentId
            });
        this.setInitialValues = (contentStateState)=>this.setState(contentStateState);
        this.resetToDefaults = ()=>this.setState({
                ...$258e0d668fcd3778$export$7e292eecf5a8f340
            });
        if (ssrContentStateData) this.populateState(ssrContentStateData);
    }
}
module.exports["defaultValues"] = $258e0d668fcd3778$export$7e292eecf5a8f340;
module.exports["ContentStateStateContainer"] = $258e0d668fcd3778$export$ade89fbf99f42685;

});

parcelRegister("cD1qu", function(module, exports) {
var $7825447594ee3eb0$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}({});
var $7825447594ee3eb0$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "current";
    ContentStatus["DRAFT"] = "draft";
    ContentStatus["ARCHIVED"] = "archived";
    return ContentStatus;
}({});
const $7825447594ee3eb0$export$5d7c5e13dde1e9b8 = [
    "draft"
];
const $7825447594ee3eb0$export$c75005e52070dee = [
    "current"
];
module.exports["PageMode"] = $7825447594ee3eb0$export$6ea4b0c62affbe44;
module.exports["ContentStatus"] = $7825447594ee3eb0$export$b2be22e9d5dd3927;
module.exports["DRAFT_STATUS"] = $7825447594ee3eb0$export$5d7c5e13dde1e9b8;
module.exports["CURRENT_STATUS"] = $7825447594ee3eb0$export$c75005e52070dee;

});

parcelRegister("aSsfA", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $cD1qu = parcelRequire("cD1qu");

const $1874c19402f3b5d2$export$da5a0d0942eec3a4 = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
};
module.exports["useGetPageMode"] = $1874c19402f3b5d2$export$da5a0d0942eec3a4;

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name || routeName === (0, $1NBp8.SPACE_SETTINGS_AGENT_CONTEXT).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("lfBMY", function(module, exports) {
var $93e6e1e47a4562a8$export$64e79c67b77e1326 = /*#__PURE__*/ function(OperationTypes) {
    OperationTypes["USE"] = "use";
    OperationTypes["LIMITED_USE"] = "limited_use";
    OperationTypes["EXTERNAL_COLLABORATOR_USE"] = "external_collaborator_use";
    OperationTypes["CREATE"] = "create";
    OperationTypes["READ"] = "read";
    OperationTypes["UPDATE"] = "update";
    OperationTypes["DELETE"] = "delete";
    OperationTypes["COPY"] = "copy";
    OperationTypes["MOVE"] = "move";
    OperationTypes["EXPORT"] = "export";
    OperationTypes["ARCHIVE"] = "archive";
    OperationTypes["PURGE"] = "purge";
    OperationTypes["PURGE_VERSION"] = "purge_version";
    OperationTypes["ADMINISTER"] = "administer";
    OperationTypes["RESTORE"] = "restore";
    OperationTypes["CREATE_SPACE"] = "create_space";
    OperationTypes["RESTRICT_CONTENT"] = "restrict_content";
    OperationTypes["CLEAR_PERMISSIONS"] = "clear_permissions";
    return OperationTypes;
}({});
module.exports["OperationTypes"] = $93e6e1e47a4562a8$export$64e79c67b77e1326;

});

parcelRegister("2wo33", function(module, exports) {

var $cFXjQ = parcelRequire("cFXjQ");


var $9Z22p = parcelRequire("9Z22p");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");


var $63cta = parcelRequire("63cta");


var $5rZJf = parcelRequire("5rZJf");

const $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    const permittedOperations = operationCheckResult?.content?.nodes?.[0]?.operations ?? [];
    const targetContentType = !!contentType ? contentType : operationCheckResult?.content?.nodes?.[0]?.type;
    if (!targetContentType) return false;
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === targetContentType);
};
const $fec7e6ab8c349d98$export$9df6fd1dd45ee771 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    // prettier-ignore
    const permittedOperations = operationCheckResult?.space?.operations ?? [];
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === contentType);
};
const $fec7e6ab8c349d98$export$e1260b60fe3f2784 = async ({ contentId: contentId, operation: operation, contentType: contentType })=>{
    const contentOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $63cta.ContentOperationsQuery),
        variables: {
            contentId: contentId
        },
        __callerPackage__: "@confluence/entity-operations"
    });
    return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: contentOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$bcbdef0ac5f1ac47 = async ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const spaceOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $5rZJf.SpaceOperationsQuery),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "@confluence/entity-operations"
    });
    return $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: spaceOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$301dbe403ac05dd5 = ({ contentId: contentId, operation: operation, contentType: contentType, status: status })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $9Z22p.default), {
        variables: {
            contentId: contentId,
            status: status
        },
        skip: !contentId,
        __callerPackage__: "@confluence/entity-operations"
    });
    if (!contentId) return false;
    if (graphQLResult?.data) return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return undefined;
};
const $fec7e6ab8c349d98$export$1fefcc1c89f32022 = ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $cFXjQ.default), {
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "@confluence/entity-operations"
    });
    // Only show the publish button if the user has permission to update (edit) this content.
    let canPerformOperation = undefined;
    if (graphQLResult?.data) canPerformOperation = $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return [
        canPerformOperation,
        graphQLResult
    ];
};
module.exports["canPerformSpaceOperation"] = $fec7e6ab8c349d98$export$9df6fd1dd45ee771;
module.exports["useCanPerformContentOperation"] = $fec7e6ab8c349d98$export$301dbe403ac05dd5;
module.exports["useCanPerformSpaceOperation"] = $fec7e6ab8c349d98$export$1fefcc1c89f32022;

});

parcelRegister("cFXjQ", function(module, exports) {
/**
 * @generated SignedSource<<ad0100fe29e950a1379a2ddc53821b8d>>
 * @relayHash 66373ccec9c74286b704fa866e6f85ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b
const $718578d961a6d231$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "66373ccec9c74286b704fa866e6f85ed",
            "id": "1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b",
            "metadata": {},
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersSpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$718578d961a6d231$var$node.hash = "cc953c6fb5811bde7a3b5ed25712839f";
var $718578d961a6d231$export$2e2bcd8739ae039 = $718578d961a6d231$var$node;
module.exports["default"] = $718578d961a6d231$export$2e2bcd8739ae039;

});

parcelRegister("9Z22p", function(module, exports) {
/**
 * @generated SignedSource<<47caf30fb1e1105daac0e1107cd5ed40>>
 * @relayHash 74ad4c4ef681c6629c8477bfc21dc6ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58
const $16467728a654d6f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "74ad4c4ef681c6629c8477bfc21dc6ca",
            "id": "e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58",
            "metadata": {},
            "name": "entityOperationsHelpersContentOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$16467728a654d6f6$var$node.hash = "a2091cf4018c51963a252c5d39ee0cbc";
var $16467728a654d6f6$export$2e2bcd8739ae039 = $16467728a654d6f6$var$node;
module.exports["default"] = $16467728a654d6f6$export$2e2bcd8739ae039;

});

parcelRegister("63cta", function(module, exports) {

var $8r0lJ = parcelRequire("8r0lJ");

const $bc89d0f4a052c761$export$a42cd9ccc4f06e9e = (0, $8r0lJ.default);
module.exports["ContentOperationsQuery"] = $bc89d0f4a052c761$export$a42cd9ccc4f06e9e;

});

parcelRegister("8r0lJ", function(module, exports) {
/**
 * @generated SignedSource<<f845cfcec4db37305d62ff3698bca4f3>>
 * @relayHash afd2c148a694798349dbf7c95e9faf5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a
const $9494deed8cae7257$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "afd2c148a694798349dbf7c95e9faf5e",
            "id": "e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a",
            "metadata": {},
            "name": "ContentOperationsQuery",
            "operationKind": "query",
            "text": "query ContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$9494deed8cae7257$var$node.hash = "ab356c29a3f1071c83869406e4056f82";
var $9494deed8cae7257$export$2e2bcd8739ae039 = $9494deed8cae7257$var$node;
module.exports["default"] = $9494deed8cae7257$export$2e2bcd8739ae039;

});

parcelRegister("5rZJf", function(module, exports) {

var $3QLqz = parcelRequire("3QLqz");

const $8e7057c5d2ae7999$export$636a01496687d185 = (0, $3QLqz.default);
module.exports["SpaceOperationsQuery"] = $8e7057c5d2ae7999$export$636a01496687d185;

});

parcelRegister("3QLqz", function(module, exports) {
/**
 * @generated SignedSource<<bba9a13a8c149665bd220be9731de503>>
 * @relayHash 5ff0445d5306228126745d8454e82696
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6
const $5b7055a8a77b29df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5ff0445d5306228126745d8454e82696",
            "id": "b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6",
            "metadata": {},
            "name": "SpaceOperationsQuery",
            "operationKind": "query",
            "text": "query SpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$5b7055a8a77b29df$var$node.hash = "c0226693d03f6d30e3056758ad9ba59d";
var $5b7055a8a77b29df$export$2e2bcd8739ae039 = $5b7055a8a77b29df$var$node;
module.exports["default"] = $5b7055a8a77b29df$export$2e2bcd8739ae039;

});

parcelRegister("7aRa9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("lKLmX", function(module, exports) {
/**
 * @generated SignedSource<<b96ce0d5fd9337cf16cb77dc6aae256c>>
 * @relayHash e4d3106ab141a2f59d322ffcf93f9edf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9ac647822522f3b78733723ca0ea25de556dc66827f7fe3ba9cf68dca8d1f328
const $c7a72aad1b5e4549$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "otherContentStatus"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "transitionType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "concreteType": "SpaceTypeSettings",
                "kind": "LinkedField",
                "name": "spaceTypeSettings",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "EnabledFeatures",
                        "kind": "LinkedField",
                        "name": "enabledFeatures",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isContentApprovalsEnabled"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v8 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "status"
    }, v10 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "number"
            }
        ]
    }, v11 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v12 = {
        "args": [
            v11 /*: any*/ ,
            {
                "kind": "Variable",
                "name": "transitionType",
                "variableName": "transitionType"
            }
        ],
        "concreteType": "ConfluenceApprovalsWorkflowStatus",
        "kind": "LinkedField",
        "name": "confluence_contentApprovalStatuses",
        "plural": true,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "allowsReviews"
            },
            {
                "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
                "kind": "LinkedField",
                "name": "displayProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    }
                ]
            }
        ]
    }, v13 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v14 = {
        "kind": "Literal",
        "name": "fetchWorkflowReview",
        "value": true
    }, v15 = {
        "kind": "Literal",
        "name": "workflowId",
        "value": "1"
    }, v16 = [
        v11 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "otherContentStatus"
        },
        v14 /*: any*/ ,
        v15 /*: any*/ 
    ], v17 = {
        "kind": "ScalarField",
        "name": "success"
    }, v18 = {
        "kind": "ScalarField",
        "name": "message"
    }, v19 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v20 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v21 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v18 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    v19 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "reviewStatus"
    }, v23 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            v22 /*: any*/ 
        ]
    }, v24 = [
        v11 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        v14 /*: any*/ ,
        v15 /*: any*/ 
    ], v25 = {
        "kind": "ScalarField",
        "name": "isActive"
    }, v26 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v27 = {
        "kind": "ScalarField",
        "name": "value"
    }, v28 = {
        "kind": "ScalarField",
        "name": "isPrimary"
    }, v29 = [
        v6 /*: any*/ ,
        v26 /*: any*/ ,
        v25 /*: any*/ ,
        {
            "concreteType": "AtlassianUserPhoto",
            "kind": "LinkedField",
            "name": "photos",
            "plural": true,
            "selections": [
                v27 /*: any*/ ,
                v28 /*: any*/ 
            ]
        }
    ], v30 = {
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v29 /*: any*/ 
    }, v31 = [
        v27 /*: any*/ 
    ], v32 = {
        "concreteType": "ConfluenceWorkflowApplicationDetails",
        "kind": "LinkedField",
        "name": "workflowApplication",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "workflowId"
            },
            {
                "kind": "ScalarField",
                "name": "contentId"
            },
            {
                "kind": "ScalarField",
                "name": "contentVersion"
            },
            {
                "kind": "ScalarField",
                "name": "contentStatus"
            },
            {
                "kind": "ScalarField",
                "name": "workflowStatusId"
            },
            v25 /*: any*/ ,
            v30 /*: any*/ ,
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "lastModificationDate",
                "plural": false,
                "selections": v31 /*: any*/ 
            },
            {
                "concreteType": "AtlassianUser",
                "kind": "LinkedField",
                "name": "modifier",
                "plural": false,
                "selections": v29 /*: any*/ 
            }
        ]
    }, v33 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "creatorAaid"
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "creationDate",
                "plural": false,
                "selections": v31 /*: any*/ 
            },
            v22 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "reviewComment"
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "reviewLastModified",
                "plural": false,
                "selections": v31 /*: any*/ 
            },
            v30 /*: any*/ ,
            {
                "concreteType": "ConfluenceReviewerDecisionInfo",
                "kind": "LinkedField",
                "name": "reviewerDecisions",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "decisionId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reviewerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "required"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "principalType"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "principalId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reviewerDecisionStatus"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "comment"
                    },
                    {
                        "concreteType": "ConfluenceApprovalsDate",
                        "kind": "LinkedField",
                        "name": "lastModifiedDate",
                        "plural": false,
                        "selections": v31 /*: any*/ 
                    },
                    {
                        "concreteType": "AtlassianUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v6 /*: any*/ ,
                            v26 /*: any*/ ,
                            v25 /*: any*/ ,
                            {
                                "concreteType": "AtlassianUserPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": [
                                    v28 /*: any*/ ,
                                    v27 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v34 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v18 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    v19 /*: any*/ ,
                    v20 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v6 /*: any*/ 
                        ],
                        "type": "BulkMutationErrorExtension"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                v7 /*: any*/ ,
                {
                    "args": v8 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                },
                v12 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v16 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v17 /*: any*/ ,
                        v21 /*: any*/ ,
                        v23 /*: any*/ 
                    ]
                },
                {
                    "args": v24 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v17 /*: any*/ ,
                        v21 /*: any*/ ,
                        v32 /*: any*/ ,
                        v33 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                v7 /*: any*/ ,
                {
                    "args": v8 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                },
                v12 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v16 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v17 /*: any*/ ,
                        v34 /*: any*/ ,
                        v23 /*: any*/ 
                    ]
                },
                {
                    "args": v24 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v17 /*: any*/ ,
                        v34 /*: any*/ ,
                        v32 /*: any*/ ,
                        v33 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "e4d3106ab141a2f59d322ffcf93f9edf",
            "id": "9ac647822522f3b78733723ca0ea25de556dc66827f7fe3ba9cf68dca8d1f328",
            "metadata": {},
            "name": "ApprovalsContextApprovalsDataQuery",
            "operationKind": "query",
            "text": "query ApprovalsContextApprovalsDataQuery($cloudId:ID!,$contentId:ID!,$contentStatus:String!,$otherContentStatus:String!,$transitionType:ConfluenceApprovalTransitionType,$spaceKey:String!){space(key:$spaceKey){id,spaceTypeSettings{enabledFeatures{isContentApprovalsEnabled}}},content(id:$contentId){nodes{status,version{number},id}},confluence_contentApprovalStatuses(cloudId:$cloudId,transitionType:$transitionType){id,allowsReviews,displayProperties{name,color}},confluence_getActiveWorkflowApplicationForOtherStatus:confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$otherContentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowReviewWithDecisions{id,reviewStatus}},confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$contentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowApplication{id,workflowId,contentId,contentVersion,contentStatus,workflowStatusId,isActive,creator{id,displayName,isActive,photos{value,isPrimary}},lastModificationDate{value},modifier{id,displayName,isActive,photos{value,isPrimary}}},workflowReviewWithDecisions{id,creatorAaid,creationDate{value},reviewStatus,reviewComment,reviewLastModified{value},creator{id,displayName,isActive,photos{value,isPrimary}},reviewerDecisions{decisionId,reviewerId,required,principalType,principalId,reviewerDecisionStatus,comment,lastModifiedDate{value},user{id,displayName,isActive,photos{isPrimary,value}}}}}}"
        }
    };
}();
$c7a72aad1b5e4549$var$node.hash = "dc99427393f687e09e4c81762eb96704";
var $c7a72aad1b5e4549$export$2e2bcd8739ae039 = $c7a72aad1b5e4549$var$node;
module.exports["default"] = $c7a72aad1b5e4549$export$2e2bcd8739ae039;

});

parcelRegister("jln20", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gK1lf = parcelRequire("gK1lf");

var $4BDAe = parcelRequire("4BDAe");


var $aWwYt = parcelRequire("aWwYt");


var $6mKj3 = parcelRequire("6mKj3");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen && (0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true)) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>{
    return (0, $42omo.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
};
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $42omo.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $42omo.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $4BDAe.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $gK1lf.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                setSidebars([]);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("gK1lf", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d = (panelId)=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d;

});

parcelRegister("i9VoI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6UYek = parcelRequire("6UYek");

const $357775eda04c1a81$export$63ba9f3f1b368ae8 = ({ onDataReceived: onDataReceived, skip: skip = false, contentId: contentId, contentType: contentType, delta: delta, subscriberId: subscriberId })=>{
    const dispatch = (0, $6UYek.useSubscriptionsDispatchContext)();
    const { setContentId: setContentId, setContentType: setContentType, removeSubscriber: removeSubscriber, addSubscriber: addSubscriber } = dispatch || {};
    (0, $42omo.useEffect)(()=>{
        if (skip || !addSubscriber || !contentId || !contentType || !removeSubscriber) return;
        setContentId?.(contentId);
        setContentType?.(contentType);
        const uniqueSubscriberId = addSubscriber({
            delta: delta,
            subscriberId: subscriberId,
            onSubscriptionData: onDataReceived
        });
        return ()=>{
            removeSubscriber({
                delta: delta,
                subscriberId: uniqueSubscriberId
            });
        };
    }, [
        skip,
        dispatch,
        contentId,
        contentType,
        setContentId,
        setContentType,
        addSubscriber,
        removeSubscriber,
        subscriberId,
        delta,
        onDataReceived
    ]);
    return null;
};
module.exports["useSubscriptionEvent"] = $357775eda04c1a81$export$63ba9f3f1b368ae8;

});

parcelRegister("1SNEF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $c0urc = parcelRequire("c0urc");

const $511608ca1b2c45b1$export$2f94e407b6c7d69d = (reloader)=>{
    const { contentId: contentId, registerReloader: registerReloader, unregisterReloader: unregisterReloader } = (0, $42omo.useContext)((0, $c0urc.QuickReloadContext));
    (0, $42omo.useEffect)(()=>{
        registerReloader(reloader);
        return ()=>{
            unregisterReloader(reloader);
        };
    // NOTE: these are only dependencies of this effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        reloader.name
    ]);
};
module.exports["useQuickReloadSubscriber"] = $511608ca1b2c45b1$export$2f94e407b6c7d69d;

});

parcelRegister("1vpkQ", function(module, exports) {

var $17wUi = parcelRequire("17wUi");

const $f378941f4cbfa1d0$export$64c46cf06596fc50 = 'approvals-pane';
const $f378941f4cbfa1d0$export$48f59b832d015459 = 400;
const $f378941f4cbfa1d0$export$e439c3cb9ea2e5e3 = 'confluence.approvals.pane.contextKey';
const $f378941f4cbfa1d0$export$bbf9a6919720fa3a = 'CURRENT';
const $f378941f4cbfa1d0$export$74a7304e4ecb72ad = 'DRAFT';
const $f378941f4cbfa1d0$export$effd283748674146 = ({ contentId: contentId, contentStatus: contentStatus })=>`${contentId}:${contentStatus}`;
/**
 * In-memory cache of the approvals pane context key.
 *
 * When the `confluence_browser_storage_controls` feature gate is enabled,
 * `sessionStorageManager.setItem` delegates to `AtlBrowserStorageSession.setItem`
 * which is **async** (it awaits IndexedDB consent checks before writing to
 * `sessionStorage`). This means a synchronous read immediately after a write
 * will return `null` — the value hasn't been persisted yet.
 *
 * The ownership helpers (`shouldRenderApprovalsPaneForContext`,
 * `syncApprovalsPaneContextOwnership`) run synchronously during React renders
 * and effects, so they need a synchronous source of truth. This in-memory
 * variable serves that purpose. Session storage is still written for
 * durability across page reloads, but in-session reads use this cache.
 */ let $f378941f4cbfa1d0$var$inMemoryContextKey = null;
const $f378941f4cbfa1d0$export$7df64ccaccec4e24 = ()=>$f378941f4cbfa1d0$var$inMemoryContextKey;
const $f378941f4cbfa1d0$export$d4f550c493c9338 = (contextKey)=>{
    $f378941f4cbfa1d0$var$inMemoryContextKey = contextKey;
    (0, $17wUi.confluenceSessionStorageInstance).setItem($f378941f4cbfa1d0$export$e439c3cb9ea2e5e3, contextKey);
};
const $f378941f4cbfa1d0$export$fbd6783260490074 = ()=>{
    $f378941f4cbfa1d0$var$inMemoryContextKey = null;
    (0, $17wUi.confluenceSessionStorageInstance).removeItem($f378941f4cbfa1d0$export$e439c3cb9ea2e5e3);
};
const $f378941f4cbfa1d0$export$823b1a6d7b43bfe4 = ({ contextKey: contextKey, storedContextKey: storedContextKey })=>storedContextKey === contextKey;
const $f378941f4cbfa1d0$export$41945f41a6acb22 = ({ isApprovalsExperimentEnabled: isApprovalsExperimentEnabled, isSidebarApprovalsPaneOpen: isSidebarApprovalsPaneOpen, contextKey: contextKey })=>{
    if (!isApprovalsExperimentEnabled || !isSidebarApprovalsPaneOpen) return false;
    return $f378941f4cbfa1d0$export$823b1a6d7b43bfe4({
        contextKey: contextKey,
        storedContextKey: $f378941f4cbfa1d0$export$7df64ccaccec4e24()
    });
};
const $f378941f4cbfa1d0$export$f29b4d98dbe0b579 = ({ isApprovalsExperimentEnabled: isApprovalsExperimentEnabled, isSidebarApprovalsPaneOpen: isSidebarApprovalsPaneOpen, contextKey: contextKey, closeApprovalsPane: closeApprovalsPane })=>{
    if (!isApprovalsExperimentEnabled) return;
    if (!isSidebarApprovalsPaneOpen) {
        $f378941f4cbfa1d0$export$fbd6783260490074();
        return;
    }
    const storedContextKey = $f378941f4cbfa1d0$export$7df64ccaccec4e24();
    if ($f378941f4cbfa1d0$export$823b1a6d7b43bfe4({
        contextKey: contextKey,
        storedContextKey: storedContextKey
    })) return;
    closeApprovalsPane();
    $f378941f4cbfa1d0$export$fbd6783260490074();
};
const $f378941f4cbfa1d0$export$c922f15693c980c9 = ({ contentId: contentId, contentStatus: contentStatus, rightSidebarContext: rightSidebarContext })=>{
    $f378941f4cbfa1d0$export$d4f550c493c9338($f378941f4cbfa1d0$export$effd283748674146({
        contentId: contentId,
        contentStatus: contentStatus
    }));
    rightSidebarContext.open($f378941f4cbfa1d0$export$64c46cf06596fc50, $f378941f4cbfa1d0$export$48f59b832d015459);
};
module.exports["APPROVALS_PANE_ID"] = $f378941f4cbfa1d0$export$64c46cf06596fc50;
module.exports["APPROVALS_PANE_CURRENT_CONTENT_STATUS"] = $f378941f4cbfa1d0$export$bbf9a6919720fa3a;
module.exports["getApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$effd283748674146;
module.exports["getStoredApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$7df64ccaccec4e24;
module.exports["clearStoredApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$fbd6783260490074;
module.exports["syncApprovalsPaneContextOwnership"] = $f378941f4cbfa1d0$export$f29b4d98dbe0b579;
module.exports["openApprovalsPaneForContext"] = $f378941f4cbfa1d0$export$c922f15693c980c9;

});


//# sourceMappingURL=EditorContentState.9c692108.js.map
